import { Typography } from '@mgmresorts/mgm-ui';
import React, { useCallback, useContext } from 'react';

import { ManualAddressForm } from '../../../components/ui/Inputs/ManualAddressForm';
import { NavigationLink } from '../../../components/ui/Link';
import { useContent } from '../../../hooks/useContent';
import PlacesPredictionsList from '../PlacesPredictionsList';
import { SignUpFormContext } from '../SignUpFormContext';

import { StyledHeading } from './styles';

export function Address() {
  const {
    bindAddress,
    bindAddress2,
    bindCity,
    bindZip,
    bindState,
    bindCountry,
    bindCustomState,
    isLoading,
    invalidFields,
    resetState,
    resetCustomState,
    removeInvalidField,
    setInvalidField,
    setSelectedPlaceId,
    useManualEntry,
    setUseManualEntry,
  } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();

  const toggleManualEntry = useCallback(() => {
    removeInvalidField('address');
    removeInvalidField('city');
    removeInvalidField('state');
    removeInvalidField('zip');
    setSelectedPlaceId();
    setUseManualEntry(manual => !manual);
  }, [setSelectedPlaceId, setUseManualEntry, removeInvalidField]);

  return (
    <div>
      <StyledHeading variant='body-medium-l' as='h2'>
        {getContentByPath('accountCreation.fields.address.title')}
      </StyledHeading>
      {useManualEntry ? (
        <>
          <ManualAddressForm
            {...{
              bindAddress,
              bindAddress2,
              bindCity,
              bindZip,
              bindState,
              resetState,
              resetCustomState,
              bindCountry,
              bindCustomState,
              isLoading,
              invalidFields,
              removeInvalidField,
              setInvalidField,
            }}
          />
          <Typography variant='body-regular-m'>
            <NavigationLink onClick={toggleManualEntry} path='#'>
              {getContentByPath('accountCreation.fields.address.prediction.insertPrediction')}
            </NavigationLink>
          </Typography>
        </>
      ) : (
        <PlacesPredictionsList onManualEntrySelection={toggleManualEntry} />
      )}
    </div>
  );
}
